import React, { useState } from 'react';

/* ─── Shared mock content ────────────────────────────────────── */
const NAV_ITEMS = [
  { icon: '📋', label: 'Orders', id: 'orders' },
  { icon: '📊', label: 'AMBR', id: 'ambr' },
  { icon: '⚙️', label: 'Settings', id: 'settings' },
];

function MockContent({ active }: { active: string }) {
  return (
    <div style={{ padding: '1.5rem', background: '#f8fafc', minHeight: 400 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: '1.25rem', border: '1px solid #e2e8f0', marginBottom: '1rem' }}>
        <div style={{ height: 12, background: '#e2e8f0', borderRadius: 6, marginBottom: 8, width: '60%' }} />
        <div style={{ height: 8, background: '#f1f5f9', borderRadius: 6, width: '40%' }} />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginBottom: '1rem' }}>
        {[1,2,3,4].map(i => (
          <div key={i} style={{ background: '#fff', borderRadius: 10, padding: '1rem', border: '1px solid #e2e8f0' }}>
            <div style={{ height: 8, background: '#e2e8f0', borderRadius: 4, marginBottom: 6, width: '50%' }} />
            <div style={{ height: 24, background: i === 1 ? '#eff6ff' : '#f0fdf4', borderRadius: 4, width: '70%' }} />
          </div>
        ))}
      </div>
      <div style={{ background: '#fff', borderRadius: 12, padding: '1.25rem', border: '1px solid #e2e8f0' }}>
        <div style={{ height: 10, background: '#e2e8f0', borderRadius: 5, marginBottom: 10, width: '80%' }} />
        {[1,2,3].map(i => (
          <div key={i} style={{ height: 8, background: '#f1f5f9', borderRadius: 4, marginBottom: 6 }} />
        ))}
      </div>
      <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem', marginTop: '1rem' }}>
        Showing: <strong>{active}</strong>
      </p>
    </div>
  );
}

/* ─── Option A: Bottom Tab Bar ───────────────────────────────── */
function OptionA() {
  const [active, setActive] = useState('orders');
  return (
    <div style={{ position: 'relative', height: 520, border: '2px solid #e2e8f0', borderRadius: 24, overflow: 'hidden', background: '#f8fafc', display: 'flex', flexDirection: 'column' }}>
      {/* Top bar */}
      <div style={{ background: '#1a2332', padding: '0.75rem 1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: '0.9rem' }}>CFA Institute</span>
        <span style={{ marginLeft: 'auto', background: '#16a34a', color: '#fff', fontSize: '0.65rem', padding: '0.15rem 0.5rem', borderRadius: 999, fontWeight: 600 }}>PROD</span>
      </div>

      {/* Content fills remaining space */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        <MockContent active={active} />
      </div>

      {/* Bottom tab bar */}
      <div style={{
        display: 'flex', background: '#fff', borderTop: '1px solid #e2e8f0',
        padding: '0.5rem 0 0.75rem',
        boxShadow: '0 -4px 12px rgba(0,0,0,0.06)',
      }}>
        {NAV_ITEMS.map(item => (
          <button key={item.id} onClick={() => setActive(item.id)} style={{
            flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
            background: 'none', border: 'none', cursor: 'pointer',
            color: active === item.id ? '#2563eb' : '#94a3b8',
            padding: '0.25rem 0',
            transition: 'color 0.15s',
          }}>
            <span style={{ fontSize: '1.25rem' }}>{item.icon}</span>
            <span style={{ fontSize: '0.65rem', fontWeight: active === item.id ? 700 : 500 }}>{item.label}</span>
            {active === item.id && (
              <div style={{ width: 20, height: 2, borderRadius: 999, background: '#2563eb', marginTop: 1 }} />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

/* ─── Option B: Hamburger + Full Overlay Drawer ──────────────── */
function OptionB() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('AMBR Analytics');
  return (
    <div style={{ position: 'relative', height: 520, border: '2px solid #e2e8f0', borderRadius: 24, overflow: 'hidden', background: '#f8fafc', display: 'flex', flexDirection: 'column' }}>
      {/* Top bar with hamburger */}
      <div style={{ background: '#1a2332', padding: '0.75rem 1rem', display: 'flex', alignItems: 'center', gap: '0.75rem', flexShrink: 0 }}>
        <button onClick={() => setOpen(true)} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: 4, padding: '0.25rem' }}>
          <div style={{ width: 20, height: 2, background: '#fff', borderRadius: 2 }} />
          <div style={{ width: 14, height: 2, background: '#fff', borderRadius: 2 }} />
          <div style={{ width: 20, height: 2, background: '#fff', borderRadius: 2 }} />
        </button>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: '0.9rem', flex: 1 }}>{active}</span>
        <span style={{ background: '#16a34a', color: '#fff', fontSize: '0.65rem', padding: '0.15rem 0.5rem', borderRadius: 999, fontWeight: 600 }}>PROD</span>
      </div>

      {/* Content */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        <MockContent active={active} />
      </div>

      {/* Overlay drawer */}
      {open && (
        <>
          {/* Backdrop */}
          <div onClick={() => setOpen(false)} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 10 }} />
          {/* Drawer */}
          <div style={{
            position: 'absolute', top: 0, left: 0, bottom: 0, width: '72%',
            background: '#1a2332', zIndex: 11, display: 'flex', flexDirection: 'column',
            boxShadow: '4px 0 24px rgba(0,0,0,0.25)',
          }}>
            <div style={{ padding: '1.25rem 1rem', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
              <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.7rem', margin: '0 0 0.2rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>CFA Institute</p>
              <p style={{ color: '#fff', fontSize: '0.85rem', fontWeight: 600, margin: 0 }}>Prod Environment</p>
            </div>
            <nav style={{ flex: 1, padding: '0.75rem 0' }}>
              {['Orders', 'AMBR Analytics', 'Settings'].map(item => (
                <button key={item} onClick={() => { setActive(item); setOpen(false); }} style={{
                  width: '100%', display: 'flex', alignItems: 'center', gap: '0.75rem',
                  padding: '0.75rem 1rem', background: active === item ? 'rgba(255,255,255,0.12)' : 'none',
                  border: 'none', cursor: 'pointer', color: '#fff', textAlign: 'left', fontSize: '0.875rem',
                  borderLeft: active === item ? '3px solid #fff' : '3px solid transparent',
                }}>
                  {item === 'Orders' ? '📋' : item === 'AMBR Analytics' ? '📊' : '⚙️'} {item}
                </button>
              ))}
            </nav>
            <div style={{ padding: '1rem', borderTop: '1px solid rgba(255,255,255,0.1)', fontSize: '0.8rem', color: 'rgba(255,255,255,0.5)' }}>
              Vishal Gupta
            </div>
          </div>
        </>
      )}
    </div>
  );
}

/* ─── Option C: Floating Action + Mini Overlay ───────────────── */
function OptionC() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('AMBR Analytics');
  return (
    <div style={{ position: 'relative', height: 520, border: '2px solid #e2e8f0', borderRadius: 24, overflow: 'hidden', background: '#f8fafc' }}>
      {/* Thin top label bar */}
      <div style={{ background: '#1a2332', padding: '0.5rem 1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: '0.85rem', flex: 1 }}>{active}</span>
        <span style={{ background: '#16a34a', color: '#fff', fontSize: '0.65rem', padding: '0.1rem 0.4rem', borderRadius: 999, fontWeight: 600 }}>PROD</span>
      </div>

      <div style={{ height: 420, overflowY: 'auto' }}>
        <MockContent active={active} />
      </div>

      {/* Floating button */}
      <button onClick={() => setOpen(o => !o)} style={{
        position: 'absolute', bottom: 20, right: 16,
        width: 48, height: 48, borderRadius: '50%',
        background: '#1a2332', border: 'none', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 4px 16px rgba(0,0,0,0.25)', zIndex: 20,
        fontSize: '1.2rem',
      }}>
        {open ? '✕' : '☰'}
      </button>

      {/* Compact pop-up menu */}
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: 'absolute', inset: 0, zIndex: 15 }} />
          <div style={{
            position: 'absolute', bottom: 76, right: 16,
            background: '#fff', borderRadius: 14, overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)', zIndex: 16,
            minWidth: 180,
          }}>
            {['Orders', 'AMBR Analytics', 'Settings'].map((item, i, arr) => (
              <button key={item} onClick={() => { setActive(item); setOpen(false); }} style={{
                width: '100%', display: 'flex', alignItems: 'center', gap: '0.6rem',
                padding: '0.75rem 1rem',
                background: active === item ? '#eff6ff' : '#fff',
                border: 'none', borderBottom: i < arr.length-1 ? '1px solid #f1f5f9' : 'none',
                cursor: 'pointer', color: active === item ? '#2563eb' : '#374151',
                fontSize: '0.875rem', fontWeight: active === item ? 600 : 400, textAlign: 'left',
              }}>
                {item === 'Orders' ? '📋' : item === 'AMBR Analytics' ? '📊' : '⚙️'} {item}
                {active === item && <span style={{ marginLeft: 'auto', fontSize: '0.75rem' }}>✓</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

/* ─── Main mockup page ───────────────────────────────────────── */
export function MobileNavMockup() {
  const options = [
    {
      label: 'A — Bottom Tab Bar',
      desc: 'iOS/Android native pattern. Always visible, zero friction to switch screens. Takes 56px at bottom.',
      pros: ['Familiar to mobile users', 'One-tap navigation', 'No hidden state'],
      cons: ['Fixed bottom space', 'Limits to 4-5 items'],
      component: <OptionA />,
      rec: false,
    },
    {
      label: 'B — Hamburger + Overlay',
      desc: 'Full-width drawer slides in from left. Sidebar completely invisible when closed — no wasted space.',
      pros: ['Zero space when closed', 'Full sidebar in familiar position', 'Content uses 100% width'],
      cons: ['Extra tap to navigate', 'Hamburger can be missed'],
      component: <OptionB />,
      rec: true,
    },
    {
      label: 'C — Floating Menu Button',
      desc: 'FAB (floating action button) in bottom-right. Tapping shows a compact pop-up nav menu.',
      pros: ['Minimal chrome', 'Content-first design', 'Trendy / modern'],
      cons: ['Button can overlap content', 'Less discoverable'],
      component: <OptionC />,
      rec: false,
    },
  ];

  return (
    <div style={{ fontFamily: "'DM Sans','Segoe UI',system-ui,sans-serif", background: '#f1f5f9', minHeight: '100vh', padding: '2rem' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 800, color: '#0f172a', marginBottom: '0.5rem', letterSpacing: '-0.02em' }}>
          Mobile Navigation — Options
        </h1>
        <p style={{ color: '#64748b', marginBottom: '2rem', fontSize: '0.9rem' }}>
          Tap the interactive elements in each mockup to see how navigation would feel.
          The current sidebar occupies 60px even collapsed — the options below fix that.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1.5rem' }}>
          {options.map(opt => (
            <div key={opt.label} style={{
              background: '#fff', borderRadius: 16,
              border: opt.rec ? '2px solid #2563eb' : '1px solid #e2e8f0',
              overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            }}>
              {/* Card header */}
              <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid #f1f5f9', display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                    <span style={{ fontWeight: 700, fontSize: '0.9rem', color: '#0f172a' }}>{opt.label}</span>
                    {opt.rec && (
                      <span style={{ background: '#2563eb', color: '#fff', fontSize: '0.65rem', padding: '0.1rem 0.45rem', borderRadius: 999, fontWeight: 700 }}>
                        RECOMMENDED
                      </span>
                    )}
                  </div>
                  <p style={{ margin: 0, fontSize: '0.78rem', color: '#64748b', lineHeight: 1.5 }}>{opt.desc}</p>
                </div>
              </div>

              {/* Interactive mockup */}
              <div style={{ padding: '1rem' }}>
                {opt.component}
              </div>

              {/* Pros / cons */}
              <div style={{ padding: '0 1.25rem 1.25rem', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                <div>
                  <p style={{ margin: '0 0 0.35rem', fontSize: '0.72rem', fontWeight: 700, color: '#16a34a', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Pros</p>
                  {opt.pros.map(p => (
                    <p key={p} style={{ margin: '0 0 0.2rem', fontSize: '0.78rem', color: '#374151' }}>✓ {p}</p>
                  ))}
                </div>
                <div>
                  <p style={{ margin: '0 0 0.35rem', fontSize: '0.72rem', fontWeight: 700, color: '#dc2626', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Cons</p>
                  {opt.cons.map(c => (
                    <p key={c} style={{ margin: '0 0 0.2rem', fontSize: '0.78rem', color: '#374151' }}>✗ {c}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: '2rem', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 12, padding: '1.25rem' }}>
          <p style={{ margin: 0, fontSize: '0.875rem', color: '#1d4ed8', fontWeight: 500 }}>
            💡 <strong>Recommendation:</strong> Option B (Hamburger + Overlay) best matches the existing desktop sidebar experience — same look and feel, just hidden until needed. It requires the least code change and will feel consistent for users switching between desktop and mobile.
          </p>
        </div>
      </div>
    </div>
  );
}
